import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.67 3.323a.7.7 0 0 1 .7.7v10.259l5.634-4.428a.7.7 0 0 1 .865 1.1l-4.272 3.358 4.375 5.214a.7.7 0 0 1-1.072.9l-4.404-5.248-1.126.884v3.915a.7.7 0 1 1-1.4 0V4.023a.7.7 0 0 1 .7-.7Zm9.585 6.382a.7.7 0 0 1 .7.7v1.292c.143-.085.298-.17.463-.255.997-.506 2.427-.966 4.042-.662a.7.7 0 0 1-.26 1.376c-1.204-.227-2.311.11-3.148.534a6.788 6.788 0 0 0-1.097.699v6.588a.7.7 0 1 1-1.4 0v-9.572a.7.7 0 0 1 .7-.7Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M19.33 19.76a.862.862 0 1 1-1.725 0 .862.862 0 0 1 1.725 0Z" />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
